import { render } from "./CheckoutForm.vue?vue&type=template&id=563f104a"
import script from "./CheckoutForm.vue?vue&type=script&lang=js"
export * from "./CheckoutForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__